import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amazon-dsp-details',
  templateUrl: './help-amazon-dsp-details.component.html',
  styleUrls: ['./help-amazon-dsp-details.component.scss']
})
export class HelpAmazonDspDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
